// Fee helpers for the Magical Mandatory Fees app's free-gift wording.
//
// The app keeps its fee list in the private cart attribute "__fees". Once it
// has written that list, Shopify attaches the gift to the line as a
// component, and sections/main-cart-items.liquid renders it with the line; the
// app's own section refresh after each write brings a new line's gift in
// without a reload. The Edit modal (assets/cart-edit.js) uses these helpers to
// reload only after the app has written the list for the size it switched to.
// "__" attributes are hidden from GET /cart.js; the app's write carries the
// list in its request body, which is what is read here, with the response as
// a fallback.

(() => {
  if (window.CartFeeSync) return;

  // A fee list's variant ids (refs): the line each fee belongs to and the
  // variants its rule matched. Null when missing or unreadable.
  function readList(raw) {
    if (raw === undefined || raw === null || raw === '') return null;
    try {
      const fees = JSON.parse(raw);
      if (!Array.isArray(fees)) return null;
      const refs = new Set();
      fees.forEach((fee) => {
        if (!fee) return;
        if (fee.target_variant_id != null) refs.add(String(fee.target_variant_id));
        (fee.matching_variant_ids || []).forEach((id) => refs.add(String(id)));
      });
      return { refs };
    } catch (error) {
      return null;
    }
  }

  const fromCart = (cart) => readList(cart && cart.attributes ? cart.attributes.__fees : undefined);

  const fromBody = (body) => {
    try {
      const data = JSON.parse(body);
      return readList(data && data.attributes ? data.attributes.__fees : undefined);
    } catch (error) {
      return null;
    }
  };

  // A pass-through window.fetch wrapper that reports the app's fee writes:
  // onStart when one is sent, onEnd with the list it saved (or null if the
  // write failed) when it settles. Requests are never altered. Returns the
  // function that removes the wrapper.
  function watchFeeWrites(onStart, onEnd) {
    const previous = window.fetch;
    const watched = function (input, init) {
      const pending = previous.apply(this, arguments);
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const body = init && typeof init.body === 'string' ? init.body : '';
        if (url.indexOf('/cart/update') !== -1 && body.indexOf('__fees') !== -1) {
          const sent = fromBody(body);
          onStart();
          pending
            .then((response) => {
              if (!response.ok) return null;
              return sent || response.clone().json().then(fromCart);
            })
            .then(
              (list) => onEnd(list),
              () => onEnd(null)
            );
        }
      } catch (error) {
        // Observation must never break a request.
      }
      return pending;
    };
    window.fetch = watched;
    return () => {
      if (window.fetch === watched) window.fetch = previous;
    };
  }

  window.CartFeeSync = { readList, fromCart, watchFeeWrites };
})();
